import axios from 'axios';
import * as Fingerprint from '@fingerprintjs/fingerprintjs'
let previousStatus;

function attachWindowEvents(store) {
    let startTime = new Date();
    let visibilityChange;
    let hidden;

    if (document.hidden !== undefined) { // Opera 12.10 and Firefox 18 and later support
        hidden = "hidden";
        visibilityChange = "visibilitychange";
    } else if (document.mozHidden !== undefined) {
        hidden = "mozHidden";
        visibilityChange = "mozvisibilitychange";
    } else if (document.msHidden !== undefined) {
        hidden = "msHidden";
        visibilityChange = "msvisibilitychange";
    } else if (document.webkitHidden !== undefined) {
        hidden = "webkitHidden";
        visibilityChange = "webkitvisibilitychange";
    } else if (document.oHidden !== undefined) {
        hidden = "oHidden";
        visibilityChange = "ovisibilitychange";
    }

    window.addEventListener('onpagehide', (e) => {
        trackWatchedTime(store, 'onpagehide', store.getTimePlayedStart, store.getPlayer.getPosition()).then();
    });

    window.addEventListener('unload', (e) => {
        trackWatchedTime(store, 'unload', store.getTimePlayedStart, store.getPlayer.getPosition()).then();
    });

    window.addEventListener('beforeunload', function(event) {
        trackWatchedTime(store, 'beforeunload', store.getTimePlayedStart, store.getPlayer.getPosition()).then();
        handleVisibilityChange(store, hidden, startTime, false);
    }, false);

    document.addEventListener(visibilityChange, function(event) {
        handleVisibilityChange(store, hidden, startTime);
    }, false);
}

function handleVisibilityChange(store, hidden, startTime, customState) {
    const date = new Date();
    const currentTime = date.getTime();
    let changeTime = date.getTime() - startTime;
    changeTime = Math.round(changeTime / 1000);

    if (customState !== true && customState !== false) {
        customState = document[hidden] ? false : true;
    }

    if (customState) {
        store.setLogEvents('Browser - User came back after ' + changeTime + ' seconds');
        if(store.getPlayer.getState() === 'paused' && (previousStatus === 'playing' || previousStatus === 'idle')) {
            store.getPlayer.play();
        }
    } else {
        store.setLogEvents('Browser - User exited after browsing for ' + changeTime + ' seconds');
        previousStatus = store.getPlayer.getState();
        if(store.getPlayer.getState() === 'playing') {
            store.getPlayer.pause();
        }
    }

    startTime = currentTime;
}

export function sendValueDimensionToGoogleAnalytics(aid, uuid, videoID, weblinkID) {
    if (window.gtab !== undefined) {
        window.gtab('event', 'page_view', {
            'UUID': uuid,
            'videoID': videoID,
            'weblinkID': weblinkID,
            'analyticID': aid
        });
    }
}

export async function generateAnalyticRequestPayload(store) {
    const uuid = await getFingerprint()

    return {
        browser: getUserBrowser(),
        device: getUserAgent(),
        httpReferrer: document.referrer,
        isDebug: store.getIsDebug,
        uuid: uuid,
        videoID: store.getVideoID,
        weblinkID: store.getWeblinkID,
    };
}

export function handleGeneratedAnalyticInRegistration(store, requestPayload, analyticId) {
    if (analyticId) {
        sendValueDimensionToGoogleAnalytics(analyticId, requestPayload.uuid, store.getVideoID, store.getWeblinkID);
    }
    attachWindowEvents(store);
}

export async function firstInteraction(store) {
    const params = await generateAnalyticRequestPayload(store);

    const url = '/campaign/video/analytic/save';
    const result = await makePostRequest(url, params);
    if (result && result.data && result.data.result > 0) {
        sendValueDimensionToGoogleAnalytics(result.data.result, params.uuid, store.getVideoID, store.getWeblinkID);
    }

    attachWindowEvents(store);
}

function getFingerprint() {
    const options = {};
    return Fingerprint.getPromise(options)
        .then((components) => {
            const values = components.map((component) => component.value);
            return Fingerprint.x64hash128(values.join(''), 31);
        });
}

function getTimeRanges(store, timeStart, timeEnd) {
    let timePlayedEnd = timeEnd;
    if (timePlayedEnd == null) {
        timePlayedEnd = store.getPlayer.getPosition();
    }

    if (timeStart < timePlayedEnd) {
        const range = [
            Math.round(timeStart),
            Math.round(timePlayedEnd),
            store.getPlayer.getPosition()
        ];
        store.setTimeRangePlayed(range);
    }
    return store.getTimeRangePlayed;
}

function getUserBrowser() {
    try {
        let e;
        const f = e.width;
    } catch (e) {
        const err = e.toString();

        if (err.indexOf('not an object') !== -1) {
            return 'Safari';
        } if (err.indexOf('Cannot read') !== -1) {
            return 'Chrome';
        } if (err.indexOf('e is undefined') !== -1) {
            return 'Firefox';
        } if (err.indexOf('Unable to get property \'width\' of undefined or null reference') !== -1) {
            if (!(document.documentMode) && !!window.StyleMedia) {
                return 'Others';
            }
            return 'Others';
        } if (err.indexOf('cannot convert e into object') !== -1) {
            return 'Others';
        }
        return 'Others';
    }
}

function getUserAgent() {
    if (window.navigator.userAgent.match(/Mobile/i)
        || window.navigator.userAgent.match(/iPhone/i)
        || window.navigator.userAgent.match(/iPod/i)
        || window.navigator.userAgent.match(/IEMobile/i)
        || window.navigator.userAgent.match(/Windows Phone/i)
        || window.navigator.userAgent.match(/Android/i)
        || window.navigator.userAgent.match(/BlackBerry/i)
        || window.navigator.userAgent.match(/webOS/i)) {
        return 'Mobile';
    } if (window.navigator.userAgent.match(/Tablet/i)
        || window.navigator.userAgent.match(/iPad/i)
        || window.navigator.userAgent.match(/Nexus 7/i)
        || window.navigator.userAgent.match(/Nexus 10/i)
        || window.navigator.userAgent.match(/KFAPWI/i)) {
        return 'Mobile';
    }
    return 'Desktop';
}

async function makePostRequest(url, params) {
    return await axios.post(url, params, {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true,
    })
}

export async function trackPlayerEvents(store, eventTypeID) {
    const params = {
        eventID: eventTypeID,
        isDebug: store.getIsDebug,
        videoID: store.getVideoID,
        weblinkID: store.getWeblinkID,
    };
    const url = '/campaign/video/analytic/event/save';
    const result = await makePostRequest(url, params);
}

export async function trackWatchedTime(store, eventType, timeStart, timeEnd) {
    const params = {
        isDebug: store.getIsDebug,
        timeRanges: getTimeRanges(store, timeStart, timeEnd),
        videoID: store.getVideoID,
        weblinkID: store.getWeblinkID,
        isAutoPlay: store.getIsAutoPlay,
    };
    store.setLogEvents('Player - ' + eventType + " in second " + store.getPlayer.getPosition().toFixed(4));
    const url = '/campaign/video/analytic/time/save';
    const result = await makePostRequest(url, params);
    if (await result.data.code > 0) {
        store.setReorderTimeRangePlayed(Object.values(result.data.range));
    }
}
